import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
  useHistory,
  useLocation
} from "react-router-dom";

export class Home extends Component {
  static displayName = Home.name;

  render () {
    const { from } = { from: { pathname: '/ghoreKeshi' } };
    localStorage.setItem('token',null);
    return (
        <Redirect to={from} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home.js